import { IRowsAndTotal } from '../types';

import { IFilterStations, IStation, IStationResponse } from './types';

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REACT_APP_API_URL } from '../../app/app.config';

const ACCESS_TOKEN_NAME = 'token';

export const stationsApi = createApi({
    reducerPath: 'stationsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: REACT_APP_API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem(ACCESS_TOKEN_NAME);
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            headers.set('Accept', 'application/json');
            headers.set('Accept-Language', 'en');
            headers.set('Content-Type', 'application/json');
            return headers;
        },
    }),
    endpoints: builder => ({
        getStationById: builder.query<IStationResponse, string>({
            query: id => `/commercial/stations/${id}`,
            keepUnusedDataFor: 10,
        }),
        getStations: builder.query<IRowsAndTotal<IStation>, IFilterStations>({
            query: filter => ({
                url: '/commercial/stations',
                params: filter,
            }),
        }),
    }),
});

export const { useGetStationByIdQuery, useLazyGetStationByIdQuery, useGetStationsQuery } =
    stationsApi;
